import React from 'react';
import './style.css';

const Loader = ({ centered = false }) => {
  return (
    <div className={`loading-container${centered ? ' loading-container--centered' : ''}`}>
      <div className="spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export const ContentLoader = () => (
  <div className="content-loader">
    <div className="spinner" />
    <p>Loading...</p>
  </div>
);

export const RouteLoader = ({ area = 'full' }) => (
  <div className={`route-loader-shell${area === 'main' ? ' route-loader-shell--main' : ''}`}>
    <Loader centered />
  </div>
);

export default Loader;
